<template>
	<svg :id="`radar-chart-${radarChartNum}`" width="100%" height="100%">
			
	</svg>
</template>
  
<script>
import * as d3 from 'd3'

export default {
	name: 'RadarChart',
	components: {
	},
	props: {
			radarChartNum: {
				Number,
			},
			color: {
				String,
				default: () => '0, 0, 0'
			},
			data: {
					Object,
					default: () => {}
			},
			colorSet: {
					Array,
					default: () => []
			}
	},
	data() {
		return {
		}
	},
	computed: {
	},
	methods: {
		angleToCoordinate(angle, value, percentage, color){
			let width = 200;
			let height = 200;
			let radialScale = d3.scaleLinear()
				.domain([0, 100])
				.range([0, 600]);
			let x = Math.cos(angle) * radialScale(value);
			let y = Math.sin(angle) * radialScale(value);
			return {"x": width / 2 + x, "y": height / 2 - y, "percentage": percentage, "color": color};
		},
		getPathCoordinates(data){
			let coordinates = [];
			for (const point in data) {
				const angle = (Math.PI / 2) + (2 * Math.PI * point / Object.keys(data).length);
				coordinates.push(this.angleToCoordinate(angle, Object.values(data[point])[0], data[point].percentage, this.colorSet[point]));
			}
			return coordinates;
		},
		updateData() {
			let width = 200;
			let height = 200;
			let svg = d3.select(`#radar-chart-${this.radarChartNum}`)
				.attr("width", width)
				.attr("height", height);

			let radialScale = d3.scaleLinear()
				.domain([0, 100])
				.range([0, 600]);
			let ticks = [2.5, 5, 7.5, 10];

			svg.selectAll("circle")
				.data(ticks)
				.join(
					enter => enter.append("circle")
						.attr("cx", width / 2)
						.attr("cy", height / 2)
						.attr("fill", "none")
						.attr("stroke", "gray")
						.attr("opacity", "0.5")
						.attr("r", d => radialScale(d))
				);
			
			svg.selectAll(".ticklabel")
				.data(ticks)
				.join(
					enter => enter.append("text")
						.attr("class", "ticklabel")
						.attr("x", width / 2 + 5)
						.attr("y", d => height / 2 - radialScale(d))
						.text(d => (d * 10).toString() + '%')
			);

			const axisArray = []
			for (let i = 0; i < Object.keys(this.data.questions).length; i++) {
				axisArray.push({i: 12, percentage: this.data.questions[i].percentage})
			}
			const axisCoords = this.getPathCoordinates(axisArray)
			svg.selectAll("line")
				.data(axisCoords)
				.join(
					enter => enter.append("line")
						.attr("x1", width / 2)
						.attr("y1", height / 2)
						.attr("x2", d => d.x)
						.attr("y2", d => d.y)
						.attr("stroke","black")
						.attr("opacity","0.5")
				);

			const textArray = []
			for (let i = 0; i < Object.keys(this.data.questions).length; i++) {
				let percenatageText;
				this.data.questions[i].percentage === 0 ? percenatageText = 'н/д' : percenatageText = this.data.questions[i].percentage
				textArray.push({i: 15, percentage: percenatageText, color: this.colorSet[i]})
			}
			const textCoords = this.getPathCoordinates(textArray)
			for (const coord in textCoords) {
				let percenatageText;
				textCoords[coord].percentage === 'н/д' ? percenatageText = 'н/д' : percenatageText = textCoords[coord].percentage.toFixed() + '%'
				svg.append("text")
					.attr("x", textCoords[coord].x)
					.attr("y", textCoords[coord].y)
					.attr("fill", textCoords[coord].color)
					.attr("font-size", "14px")
					.attr("text-anchor", "middle")
					.attr("transform", "translate(0, 5)")
					.text(percenatageText)
			}
			const curve = d3.line().curve(d3.curveCardinal.tension(0));
			const convertedData = (this.data.questions).map((question) => {
				return {
					i: question.percentage / 10,
				}
			})
			const points = this.getPathCoordinates(convertedData)
			const coordinateArray = [];
			for (let key in points) {
				const { x, y } = points[key];
				coordinateArray.push([x, y]);
			}
			coordinateArray.push([points[0].x, points[0].y]);
			svg.append('path')
				.attr('d', curve(coordinateArray))
				.attr("fill", "gray")
				.attr("opacity", 0.8)
			
			for (const point in coordinateArray.slice(0, -1)) {
				svg.append("circle")
					.style("fill", this.colorSet[point])
					.attr("r", 7)
					.attr("cx", coordinateArray[point][0])
					.attr("cy", coordinateArray[point][1]);
			}
		}
	},
	mounted() {
		this.updateData()
	},
	watch: {
		data() {
			let svg = d3.select(`#radar-chart-${this.radarChartNum}`)
			svg.selectAll("*").remove();
			this.updateData()
		}
	}

}
</script>

<style lang="sass">
.ticklabel
	font-size: 10px
	text-anchor: start
	transform: translate(5px, 0)
	opacity: 0.7

</style>
